module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-brands-400.ttf?bbf83f8bb1039cd860051299d64ebcfd";